"use strict";

PF.ListCrudPage = class ListCrudPage extends PF.List
	{
	static get options()
		{
		return {
			addable: true,
			editable: true,
			selectable: true,
			deletable: true,

			toastOnDelete: true,
			toastOnDeleteText: 'Данные успешно сохранены',

			itemClass: PF.ListCrudPage.Item,

			itemEditTrait: PF.ListCrudPage.Item.Edit,
			itemDndTrait: PF.List.Item.Dnd,
			addTrait: PF.ListCrudPage.Add,
			searchTrait: PF.List.Search,

			editPage: undefined
		};
		}

	init()
		{
		this.selectMode = false;
		this.selected = [];

		super.init();

		this.dom.element.addClass('pf-list-crud');

		// this.useTrait(PF.List.Add, this.addable);
		this.useTrait(PF.List.Select, this.selectable);
		this.useTrait(PF.List.Delete, this.deletable);
		}
	};

PF.ListCrudPage.Item = class ItemPage extends PF.List.Item
	{
	static get options()
		{
		return {
			list: undefined,
			index: undefined,
			data: undefined,
			title: `@{model.name}`,
			newTitle: `Создать`,
			formConfig: {}
		};
		}

	get renderer()
		{
		//language=HTML
		return `
			<li pf="item">
				<label class="item-checkbox item-content item-link" for="null" pf="label">
					<input type="checkbox" pf="selectInput">
					<i class="icon icon-checkbox" pf="selectCheckbox"></i>
					${this.itemInner} 
				</label>
			</li>
		`;
		}

	get itemInner()
		{
		return ``;
		}

	onRender(event)
		{
		super.onRender(event);
		this.useTrait(PF.ListCrud.Item.Select, this.list.selectable);

		if (this.list.selectable === false)
			{
			this.dom.on('fastClick', () => this.trigger('startEdit'));
			}
		}
	};


